/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * Result of a company type merge operation
 * @export
 * @interface CompanyTypeMergeResponse
 */
export interface CompanyTypeMergeResponse {
    /**
     * ID of the company type that was disabled
     * @type {string}
     * @memberof CompanyTypeMergeResponse
     */
    sourceCompanyTypeId: string;
    /**
     * ID of the company type that companies will be migrated to
     * @type {string}
     * @memberof CompanyTypeMergeResponse
     */
    targetCompanyTypeId: string;
    /**
     * Number of companies that will be migrated asynchronously
     * @type {number}
     * @memberof CompanyTypeMergeResponse
     */
    affectedCompanyCount: number;
}

/**
 * Check if a given object implements the CompanyTypeMergeResponse interface.
 */
export function instanceOfCompanyTypeMergeResponse(value: object): value is CompanyTypeMergeResponse {
    if (!('sourceCompanyTypeId' in value) || value['sourceCompanyTypeId'] === undefined) return false;
    if (!('targetCompanyTypeId' in value) || value['targetCompanyTypeId'] === undefined) return false;
    if (!('affectedCompanyCount' in value) || value['affectedCompanyCount'] === undefined) return false;
    return true;
}

export function CompanyTypeMergeResponseFromJSON(json: any): CompanyTypeMergeResponse {
    return CompanyTypeMergeResponseFromJSONTyped(json, false);
}

export function CompanyTypeMergeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyTypeMergeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceCompanyTypeId': json['sourceCompanyTypeId'],
        'targetCompanyTypeId': json['targetCompanyTypeId'],
        'affectedCompanyCount': json['affectedCompanyCount'],
    };
}

export function CompanyTypeMergeResponseToJSON(value?: CompanyTypeMergeResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sourceCompanyTypeId': value['sourceCompanyTypeId'],
        'targetCompanyTypeId': value['targetCompanyTypeId'],
        'affectedCompanyCount': value['affectedCompanyCount'],
    };
}

